import React, { useEffect } from "react";

import { ReloadOutlined } from "@ant-design/icons";
import { Button as AntdButton, Col, Row, Table, Tag, Typography } from "antd";
import moment from "moment-timezone";

const { Title, Text } = Typography;

// The API does not publish the loyalty transaction type enum, only the
// redemption value is confirmed by the LoyaltyTransactionHistory response.
const REDEEMED_TRANSACTION_TYPE = 3;

export default function LoyaltyPointsList({
  transactions = [],
  availableLoyaltyPoints,
  loading,
  onLoad,
  onRefresh,
}) {
  useEffect(() => {
    onLoad?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      title: "Transaction",
      dataIndex: "notes",
      key: "notes",
      render: (text, record) => {
        const cst = moment.utc(record?.transactionDate).tz("America/Chicago");

        return (
          <td style={{ display: "grid" }}>
            <div
              style={{
                fontWeight: "bold",
                display: "flex",
                alignItems: "flex-start",
                gap: 4,
              }}
            >
              <span style={{ fontWeight: "inherit" }}>{record?.notes}</span>
              {record?.transactionType === REDEEMED_TRANSACTION_TYPE && (
                <Tag color="green" style={{ marginRight: 0 }}>
                  Redeemed
                </Tag>
              )}
            </div>
            {record?.formattedServicesAndBoosts ? (
              <span style={{ fontSize: "12px" }}>
                {record?.formattedServicesAndBoosts}
              </span>
            ) : null}
            <span style={{ fontSize: "12px", color: "gray" }}>
              {record?.transactionDate
                ? `${cst.format("MMMM, DD YYYY - h:mm a")} (CST)`
                : "-"}
            </span>
          </td>
        );
      },
    },
    {
      title: "Points",
      dataIndex: "points",
      key: "points",
      align: "right",
      width: 80,
      render: (text, record) => {
        return (
          <p
            style={{
              fontSize: 14,
              fontWeight: 500,
              fontFamily: "TradeGothic",
              margin: 0,
            }}
          >
            {record?.points ?? 0}
          </p>
        );
      },
    },
  ];

  return (
    <Row>
      <Col xs={24}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 16,
            gap: 4,
          }}
        >
          <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
            <Text>
              Current Points:
            </Text>
            <Text>
              {(availableLoyaltyPoints ?? 0).toLocaleString()}
            </Text>
          </div>

          <AntdButton
            size="small"
            rounded={true}
            shape="circle"
            onClick={() => (onRefresh ?? onLoad)?.()}
            icon={<ReloadOutlined />}
          />
        </div>

        <Table
          tableLayout="auto"
          rowKey={(record) => record?.id}
          loading={loading}
          locale={{ emptyText: "No Reward Points" }}
          dataSource={transactions}
          columns={columns}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: [15, 25, 50, 100, 250],
          }}
          scroll={{
            x: true,
          }}
        />
      </Col>
    </Row>
  );
}
